import { every, isEmpty } from 'lodash';
import { utils, writeFile as writeFileXLSX } from 'xlsx';
import { toast } from 'react-toastify';

export const validateEmail = (value: string) => {
  const emailRegex =
    // eslint-disable-next-line max-len, no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value) ? '' : 'Please enter valid Email';
};

//this function will validate password
export const validatePassword = (password: string) => {
  const passwordRegex = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
  return password.match(passwordRegex)
    ? ''
    : 'password must contain at least 6 characters, including UPPER/lowercase and numbers';
};
export const validateConfirmPassword = (password: string, confirmPassword: string) => {
  if (password !== confirmPassword) {
    return 'Password and confirm password does not match';
  }
  return '';
};
export const isEmptyErrors = (errors: object) => every(errors, (value) => isEmpty(value));

//*valoidate username;
export const toaster = (type: 'error' | 'success' | 'warning' | 'info', message: string) => {
  toast[type](message);
};

export const validateDate = (date: Date) => {
  // Regex for date format yyyy-mm-dd
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  // Convert Date object to string in yyyy-mm-dd format
  const dateString = date instanceof Date ? date.toISOString().split('T')[0] : date;

  // Validate the date string
  return dateString.match(dateRegex) ? '' : 'Enter valid date in yyyy-mm-dd format';
};

//convert date to 20, Feb 2023 this formate
export const convertDate = (date: Date) => {
  const d = new Date(date);
  const month = d.toLocaleString('default', { month: 'short' });
  return `${d.getDate()}, ${month} ${d.getFullYear()}`;
};

//convert timestamp duration to min and sec
export const convertDuration = (duration: number) => {
  const min = Math.floor(duration / 60);
  const sec = duration % 60;
  return `${min}:${sec}`;
};

export const downloadExcel = (data: any[], fileName: string) => {
  // console.log(data);

  // console.log(filteredData, 'filter');

  // const test = [
  //   {
  //     fname: 'shivanshi',
  //   },
  // ];

  const ws = utils.json_to_sheet(data);
  // console.log(ws, 'wssss');

  const wb = utils.book_new();
  // console.log(wb, 'wbbbb');

  utils.book_append_sheet(wb, ws, 'Data');
  // console.log(utils.book_append_sheet(wb, ws, 'Data'));

  writeFileXLSX(wb, `${fileName}.xlsx`);
  // console.log(writeFileXLSX(wb, `${fileName}.xlsx`), 'pppppppp');
};

export const convertToTwoDigit = (value: number) => (value < 10 ? `0${value}` : value);

export const formatDateAccordingToDateType = (date: Date, type?: string) => {
  if (!date) return;

  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const year = date.getFullYear();

  switch (type) {
    case 'dd/mm/yyyy':
      return `${day}/${month}/${year}`;
    case 'mm/dd/yyyy':
      return `${month}/${day}/${year}`;
    case 'yyyy/mm/dd':
      return `${year}/${month}/${day}`;
    case 'yyyy/dd/mm':
      return `${year}/${day}/${month}`;
    case 'yyyy-mm-dd':
      return `${year}-${month}-${day}`;
    case 'yyyy-dd-mm':
      return `${year}-${day}-${month}`;
    case 'dd-mm-yyyy':
      return `${day}-${month}-${year}`;
    case 'mm-dd-yyyy':
      return `${month}-${day}-${year}`;
    default:
      return `${day}/${month}/${year}`;
  }
};

//convert in to this formate 35:41 Min
export const convertDurationToMinutes = (duration: number) => {
  const min = Math.floor(duration / 60);
  const sec = Math.floor(duration % 60);
  //add 0 if sec is less than 10 and also for min
  const secWithZero = sec < 10 ? `0${sec}` : sec;
  const minWithZero = min < 10 ? `0${min}` : min;
  return `${minWithZero} : ${secWithZero} Min`;
};

export const formateTimeStampDate = (timestamp: string) => {
  const date = new Date(timestamp);

  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric', // "2021"
    month: 'short', // "Dec"
    day: '2-digit', // "14"
  });

  const formattedTime = date.toLocaleTimeString('en-US', {
    hour: '2-digit', // "09"
    minute: '2-digit', // "32"
    hour12: true, // AM/PM format
  });

  return `${formattedDate}, at ${formattedTime}`;
};

export const convertTimeInToMinutesandSeconds = (time: number) => {
  //precison to 2 decimal
  const timeInMinutes = Math.floor(time / 60);

  // const timeInSeconds = Math.floor(time % 60).toPrecision(2);

  const timeInSeconds = Math.floor(time % 60);

  if (timeInSeconds < 10) {
    return `${timeInMinutes}:0${timeInSeconds}`;
  }

  return `${timeInMinutes}:${timeInSeconds.toPrecision(2)}`;
};
